<!-- modal.component.html -->
@if (isOpen) {
<div class="fixed inset-0 flex items-center justify-center modal z-99 p-2 sm:p-4">
  <!-- Backdrop -->
  @if (!isFullscreen) {
  <div
    class="fixed inset-0 h-full w-full bg-gray-400/50 backdrop-blur-[32px]"
    (click)="onBackdropClick($event)"
  ></div>
  }
  <!-- Modal Content -->
  <div #contentBox
    [ngClass]="isFullscreen ? 'w-full h-full' : 'relative w-full rounded-2xl sm:rounded-3xl bg-white dark:bg-gray-900 my-2 sm:my-8 flex flex-col max-h-[calc(100dvh-1rem)] sm:max-h-[calc(100vh-5rem)]'"
    [class]="className"
  >
    <!-- Remove the built-in close button completely -->
    <ng-content></ng-content>
  </div>
</div>
}